import * as TW from './tailwindhelpers';

import Alpine from 'alpinejs';
import Swiper, { EffectFade, Thumbs, Autoplay, Navigation } from 'swiper';
import { gsap } from 'gsap';
import { speed } from 'jquery';
// import Swup from 'swup';

window.Alpine = Alpine;

// Alpine.data('quantity', () => ({
// 	setSize() {
// 		this.$refs.input.setAttribute('size', this.$refs.input.value.toString().length);
// 		this.$refs.input.style = 'width: ' + (parseInt(this.$refs.input.value.toString().length) + 1) + 'ch';
// 	},
// 	enableUpdateCartButton() {
// 		document.querySelector('button[name="update_cart"]').removeAttribute('disabled');
// 	},
// 	increment() {
// 		const newValue = parseInt(this.$refs.input.value) + 1;
// 		const max = this.$refs.input.max;
// 		this.$refs.input.value = max ? (newValue <= max ? newValue : max) : newValue;
// 		this.setSize();
// 		this.enableUpdateCartButton();
// 	},
// 	decrement() {
// 		const newValue = parseInt(this.$refs.input.value) - 1;
// 		const min = this.$refs.input.min;
// 		this.$refs.input.value = newValue >= min ? newValue : min;
// 		this.setSize();
// 		this.enableUpdateCartButton();
// 	},
// 	init() {
// 		this.$refs.input.style = 'appearance: textfield; margin: 0; width: 4ch';

// 		const before = document.createElement('button');
// 		before.innerText = '-';
// 		before.setAttribute('x-on:click.prevent', 'decrement()');
// 		before.style = 'user-select: none;';
// 		const after = document.createElement('button');
// 		after.innerText = '+';
// 		after.setAttribute('x-on:click.prevent', 'increment()');
// 		after.style = 'user-select: none;';

// 		this.$refs.input.insertAdjacentElement('beforebegin', before);
// 		this.$refs.input.insertAdjacentElement('afterend', after);

// 		this.setSize();
// 	},
// }));
Alpine.start();

// Init swipers
document.addEventListener('DOMContentLoaded', () => {
	Swiper.use([Thumbs, EffectFade, Autoplay, Navigation]);
	let products = document.querySelector('#product-single-swiper');
	let productThumbs = document.querySelector('#product-single-thumbnail-swiper');

	let productThumbnailSwiper = new Swiper(productThumbs, {
		autoHeight: false,
		watchSlidesProgress: true,
		slidesPerView: 'auto',
		freeMode: false,
		allowTouchMove: false,
	});

	let productSwiper = new Swiper(products, {
		duration: 500,
		autoHeight: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 3000,
			waitForTransition: false,
		},
		thumbs: {
			swiper: productThumbnailSwiper,
		},
		navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
		loop: true,
	});

	/*
	 * Listen to select change in variations form
	 * and slide to according image in swiper
	 */
	let variationsForm = document.querySelector('form.variations_form');

	function slideOnVariationChange(e) {
		const slug = e.srcElement.value;
		const slides = Array.from(productSwiper.slides);
		const slideIndex = slides.findIndex((s) => s.hasAttribute('data-variant') && s.dataset.variant == slug);
		productSwiper.slideTo(slideIndex);
	}

	if (variationsForm != undefined) {
		if (productSwiper != undefined) {
			variationsForm.addEventListener('change', (e) => {
				slideOnVariationChange(e);
			});
		}
	}

	// Product category swiper
	var swiper = new Swiper('.CategorySwiper', {
		slidesPerView: 'auto',
		spaceBetween: 16,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
	// Lookbook Prev Swiper
	var swiper = new Swiper('.LookbookSwiper', {
		spaceBetween: 30,
		effect: 'fade',
		autoplay: {
			delay: 500,
			disableOnInteraction: false,
		},
		speed: 100,
	});
});

// Link video to progress bars (only frontpage)
document.addEventListener('DOMContentLoaded', () => {
	if (document.body.classList.contains('home')) {
		let video = document.querySelector('video');
		let pbars = [...document.querySelectorAll('header, nav, footer')];
		// let header = document.querySelector('header');

		let yellow = TW.fullConfig.theme.colors.secondary.DEFAULT;
		video.addEventListener('timeupdate', (e) => {
			let percentage = (video.currentTime / video.duration) * 100;

			// gsap.to(header, {
			// 	background: `linear-gradient(to right, ${yellow} ${percentage}%, white ${percentage}%)`,
			// });

			pbars.map((pb) => {
				gsap.to(pb, {
					background: `linear-gradient(to right, ${yellow} ${percentage}%, white ${percentage}%)`,
				});
			});
		});
	}
});

// Random Panther
const backgroundImages = [
	'/wp-content/themes/oor-theme/img/panther-1.svg',
	'/wp-content/themes/oor-theme/img/panther-2.svg',
	'/wp-content/themes/oor-theme/img/panther-3.svg',
	'/wp-content/themes/oor-theme/img/panther-4.svg',
	'/wp-content/themes/oor-theme/img/panther-5.svg',
	'/wp-content/themes/oor-theme/img/panther-6.svg',
	'/wp-content/themes/oor-theme/img/panther-7.svg',
	'/wp-content/themes/oor-theme/img/panther-8.svg',
	// Add more image URLs as needed
];

function getRandomImage() {
	const randomIndex = Math.floor(Math.random() * backgroundImages.length);
	return backgroundImages[randomIndex];
}

function setRandomBackground() {
	if (Math.random() < 0.7) return;
	const overlay = document.createElement('img');
	overlay.classList.add('overlayyy');
	overlay.style = 'position: fixed; z-index: 99; inset: 0px; width: 100%; height: 100%; object-fit: cover; background-color: white';
	overlay.src = getRandomImage();
	document.body.appendChild(overlay);
	setTimeout(() => {
		document.body.removeChild(overlay);
	}, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
	setRandomBackground(); // Set a random background image when the page loads
});

// Tests
// console.log(TW.fullConfig);

jQuery(document).ready(function ($) {
    const woocommerceCart = $('.woocommerce-cart');

    if (woocommerceCart.length > 0) {
        woocommerceCart.on('change', 'input.qty', function() {
            const updateCartButton = $("[name='update_cart']");
            if (updateCartButton.length > 0) {
                updateCartButton.trigger("click");
            }
        });
    }
});
